module.exports = __webpack_public_path__ + "img/server.f13cf274.svg";